import instance from '@/utils/instance';

//获取字典数据
export function getDictData(params) {
	return instance({
		url: `/webL_api/system/opera/queryLexicon/${params}`,
		method: 'get',
	});
}
